module.exports = __webpack_public_path__ + "img/guyana.e92264b1.png";